// Versión del software mostrada en el frontend (login, home, drawers, asistente).
// Se inyecta en build-time por el workflow de despliegue (REACT_APP_SW_VERSION,
// ver .github/workflows/deploy-frontend-build.yml). El fallback hardcodeado se usa
// en builds locales o si la variable no está definida.
export const SW_VERSION = process.env.REACT_APP_SW_VERSION || "v2026.06.24";

export default SW_VERSION;
